// extracted by mini-css-extract-plugin
export default {"wrapper":"login-streak-popup_wrapper__n-5mu","popup":"login-streak-popup_popup__3TI4O"};